import { render, staticRenderFns } from "./AboutUs_Increase.vue?vue&type=template&id=4ef11196&"
import script from "./AboutUs_Increase.vue?vue&type=script&lang=js&"
export * from "./AboutUs_Increase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports